import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../../App/ModalCamposObligatorios'

function TablaProductoVivero(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_06predioMap = props.productosMap
    let fc_36 = useSelector(store => store.FC_36Solicitud.fc_36)
    const actualizacionprediosviveros = props.actualizacionprediosviveros
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleVivero, handdleRemoveViveroPrev, handdleEditViveroPrev, viveros, handdleViverosBaja } = api
    // const { predioMap, handdlePredioMap } = props.Mappredio
    const [id, setId] = React.useState()
    const [cultivado, setcultivado] = React.useState(false)
    const [semicultivado, setsemicultivado] = React.useState(false)
    const [silvestre, setsilvestre] = React.useState(false)
    const [nombreparaje, setnombreparaje] = React.useState('')
    const [estado, setestado] = React.useState('')
    const [distrito, setdistrito] = React.useState('')
    const [codigopostal, setcodigopostal] = React.useState('')
    const [municipio, setmunicipio] = React.useState('')
    const [localidad, setlocalidad] = React.useState('')
    const [calle, setcalle] = React.useState('')
    const [numeroexterior, setnumeroexterior] = React.useState('')

    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = [
        {
            field: 'nombreparaje', headerName: 'Nombre paraje', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .7,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.nombreparaje}`} arrow>
                        <label>{`${params.row.nombreparaje} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'domicilio', headerName: 'Domicilio Completo', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.domicilio}`} arrow>
                        <label>{`${params.row.domicilio} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .3,
            renderCell: (params) => (
                <Fragment>
                    {params.row.baja === null ?
                        <Fragment>
                            {fc_06predioMap?.length > 0 ? (
                                <Fragment>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                                </Fragment>)}
                        </Fragment>
                        : ((params.row.baja === false || params.row.baja === true) && params.row.isbaja === false) ?
                            <Fragment>
                                <button className={params.row.baja === false ? `btn btn-outline-warning ms-1` : params.row.baja === true ? `btn btn-danger ms-1` : ''} onClick={() => { botonBaja(params.row) }} >Dar de Baja</button>
                            </Fragment> : ''
                    }
                </Fragment>

            )
        },
    ]


    const botonEliminar = async (params) => {
        handdleRemoveViveroPrev({ data: params.row })
    }
    const botonBaja = async (params) => {
        handdleViverosBaja(params)
    }

    const botonGuardar = async () => {
        let dato = {
            id: id, nombreparaje: nombreparaje, estado: estado, distrito: distrito,
            municipio: municipio, localidad: localidad, calle: calle, numeroexterior: numeroexterior, codigopostal: codigopostal,
            domicilio: numeroexterior + ',' + calle + ',' + localidad + ',' + municipio + ',' + distrito + ',' + estado + ',' + codigopostal,
            cultivado: cultivado ? 'Si' : 'No', semicultivado: semicultivado ? 'Si' : 'No', silvestre: silvestre ? 'Si' : 'No',
            baja: null, alta: true
        }
        handdleEditViveroPrev(dato)
        setnombreparaje('')
        setestado('')
        setdistrito('')
        setmunicipio('')
        setlocalidad('')
        setcalle('')
        setnumeroexterior('')
        setcodigopostal('')
        setcultivado(false)
        setsemicultivado(false)
        setsilvestre(false)
        setEditar(false)
        setproductoMap([])
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setnombreparaje(params.row.nombreparaje)
        setestado(params.row.estado)
        setdistrito(params.row.distrito)
        setmunicipio(params.row.municipio)
        setlocalidad(params.row.localidad)
        setcalle(params.row.calle)
        setnumeroexterior(params.row.numeroexterior)
        setcodigopostal(params.row.codigopostal)
        setcultivado(params.row.cultivado === 'Si' ? true : false)
        setsemicultivado(params.row.semicultivado === 'Si' ? true : false)
        setsilvestre(params.row.silvestre === 'Si' ? true : false)
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(viveros)
    React.useEffect(() => {
        setRows(viveros)
    }, [viveros])

    const botonAgregar = async () => {

        if (estado.toString().length > 0 && municipio.length > 0 && localidad.length > 0) {
            let dato = {
                id: uuidv4(), nombreparaje: nombreparaje, estado: estado, distrito: distrito,
                municipio: municipio, localidad: localidad, calle: calle, numeroexterior: numeroexterior, codigopostal: codigopostal,
                domicilio: numeroexterior + ',' + calle + ',' + localidad + ',' + municipio + ',' + distrito + ',' + estado + ',' + codigopostal,
                cultivado: cultivado ? 'Si' : 'No', semicultivado: semicultivado ? 'Si' : 'No', silvestre: silvestre ? 'Si' : 'No',
                baja: null, alta: true
            }
            handdleVivero(dato)
            setnombreparaje('')
            setestado('')
            setdistrito('')
            setmunicipio('')
            setlocalidad('')
            setcultivado(false)
            setsemicultivado(false)
            setsilvestre(false)
            setcalle('')
            setnumeroexterior('')
            setcodigopostal('')
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setnombreparaje('')
        setestado('')
        setdistrito('')
        setmunicipio('')
        setlocalidad('')
        setcultivado(false)
        setsemicultivado(false)
        setsilvestre(false)
        setcalle('')
        setnumeroexterior('')
        setcodigopostal('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_06predioMap.filter(anexo => anexo?.idfc_36_anexoviveros === params.row.idfc_36_anexoviveros)
        setproductoMap(filtro[0])
        if (params.row.idfc_36_anexoviveros) setId(params.row.idfc_36_anexoviveros)
        else setId(params.row.idfc_36_anexoviveros)
        setnombreparaje(params.row.nombreparaje)
        setestado(params.row.estado)
        setdistrito(params.row.distrito)
        setmunicipio(params.row.municipio)
        setlocalidad(params.row.localidad)
        setcalle(params.row.calle)
        setnumeroexterior(params.row.numeroexterior)
        setcodigopostal(params.row.codigopostal)
        setcultivado(params.row.cultivado === 'Si' ? true : false)
        setsemicultivado(params.row.semicultivado === 'Si' ? true : false)
        setsilvestre(params.row.silvestre === 'Si' ? true : false)
        setEditar(true)
    }

    return (
        <>
            <FormGroup>
                {((!actualizacionprediosviveros || (fc_36.viverista && fc_36.viveristaaltabaja))|| fc_36.cambiorazon  ) &&
                    <div className='row align-items-center'>
                        {/*<div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                Tipo de plantación
                            </label><br />
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                            <input className={`form-check-input me-1  ${productoMap?.validacioncheck !== undefined ? (productoMap.validacioncheck || productoMap.validacioncheck === false) ?
                                'inputValidado' : '' : ('')}`} type="checkbox"
                                name="paracomprayventa"
                                checked={cultivado}
                                onChange={e => { setcultivado(e.target.checked) }}
                            />

                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                Cultivado
                            </label><br />
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.paracomprayventa : ''}</span>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                            <input className={`form-check-input me-1  ${productoMap?.validacioncheck !== undefined ? (productoMap.validacioncheck || productoMap.validacioncheck === false) ? 'inputValidado' : '' : ('')}`} type="checkbox"
                                name="paracomprayventa"
                                checked={semicultivado}
                                onChange={e => { setsemicultivado(e.target.checked) }}
                            />

                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                Semicultivado
                            </label><br />
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.paracomprayventa : ''}</span>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                            <input className={`form-check-input me-1  ${productoMap?.validacioncheck !== undefined ? (productoMap.validacioncheck || productoMap.validacioncheck === false) ? 'inputValidado' : '' : ('')}`}
                                type="checkbox"
                                name="paracomprayventa"
                                checked={silvestre}
                                onChange={e => { setsilvestre(e.target.checked) }}
                            />

                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                Silvestre
                            </label><br />
                            </div>*/}
                        <div className='col-md-6 mt-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Nombre del paraje'
                                    value={nombreparaje} onChange={e => setnombreparaje(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>Nombre del paraje</label>
                                {nombreparaje.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-6 mt-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (
                                    productoMap?.validacioncheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                    id="floatingInput" placeholder='Estado'
                                    value={estado} onChange={e => setestado(e.target.value)}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>Estado</label>
                            </div>
                            {estado.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Distrito'
                                    value={distrito} onChange={e => setdistrito(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>Distrito</label>
                            </div>
                            {distrito.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Codigo Postal'
                                    value={codigopostal} onChange={e => setcodigopostal(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>Codigo Postal</label>
                            </div>
                            {codigopostal.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="text" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Municipio'
                                    value={municipio} onChange={e => setmunicipio(e.target.value)}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>Municipio</label>
                                {municipio.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="text" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Localidad'
                                    value={localidad} onChange={e => setlocalidad(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>Localidad</label>
                                {localidad.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="text" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Calle'
                                    value={calle} onChange={e => setcalle(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>Calle</label>
                                {localidad.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="text" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Numero Exterior'
                                    value={numeroexterior} onChange={e => setnumeroexterior(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>Numero Exterior</label>
                                {localidad.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                            </div>
                        </div>
                    </div>}
            </FormGroup>
            {(!actualizacionprediosviveros || (fc_36.viverista && fc_36.viveristaaltabaja)) && <Fragment>
                {!editar ?
                    <Fragment>
                        {fc_06predioMap?.length === 0 ? (
                            <Fragment>
                                <div className='col-md-3'></div>
                                <div className='text-center'>
                                    <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar vivero</button>
                                </div>
                                <br />
                            </Fragment>) : ''}
                    </Fragment>
                    : (
                        <Fragment>
                            <div className='row'>
                                <div className='col-md-3'></div>
                                <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar vivero</button>
                                <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                            </div>
                            <br />
                        </Fragment>
                    )}</Fragment>}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '103%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

        </>
    )

}
export default TablaProductoVivero